import React, { useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loader from '../../components/Loader'

const CloverCallback = () => {
	const navigate = useNavigate()

	const userLogin = useSelector((state) => state.userLogin)
	const { userInfo } = userLogin

	const callCallBack = async (code, merchant_id, config) => {
		const url = process.env.REACT_APP_API_URL
		await axios
			.get(
				`${url}/api/clover/callback/?code=${code}&merchant_id=${merchant_id}`,
				config
			)
			.then((response) => {
				console.log('Successfully authenticated with Clover:', response.data)
				navigate('/homepage')
			})
			.catch((error) => {
				alert('Error:', error)
				console.error('Error during Clover authentication:', error)
				navigate('/homepage')
			})
	}

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)
		const code = urlParams.get('code')
		const merchant_id = urlParams.get('merchant_id')
		const error = urlParams.get('error')

		let config

		if (userInfo) {
			config = {
				headers: {
					'Content-type': 'application/json',
					Authorization: `Bearer ${userInfo.access}`,
				},
			}
		}

		if (error) {
			console.error('OAuth error:', error)
		} else if (code) {
			callCallBack(code, merchant_id, config)
		} else {
			console.log('Authorization code missing.')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [navigate])

	return (
		<div>
			<Loader />
		</div>
	)
}

export default CloverCallback
